<template>
  <div>
    <div class="row">
      <div class="col-md-4 col-sm-6 col-xs-6">
        <base-button
          @click="exportToExcel()"
          class="btn-dark float-sm-none float-md-left more-margin-top"
          >Excel</base-button
        >
      </div>

      <div class="col-md-3 offset-md-5">
        <label for="searchBox">Search:</label>
        <el-input
          id="searchBox"
          type="search"
          class="mb-3 search-input"
          clearable
          prefix-icon="el-icon-search"
          placeholder="Search all Orders..."
          v-model="searchText"
          v-b-popover.hover.bottom="
            'Search results appear immediately upon typing.'
          "
        ></el-input>
      </div>
    </div>
    <div class="row">
      <el-table
        :data="getResults.results"
        :cell-style="tableRowClassName"
        :default-sort="{ prop: 'orderId', order: 'descending' }"
        role="table"
        aria-label="Orders Table"
        table-layout="auto"
      >
        <el-table-column :min-width="110" align="left" label="Actions">
          <template slot-scope="props">
            <router-link
              :to="`/order/view/${props.row.orderId}`"
              class="btn-link link-dark"
              :aria-label="`View Order No ${props.row.orderId}`"
            >
              <i class="tim-icons icon-zoom-split"></i>
              <span class="hide-if-small-screensize">View</span>
            </router-link>
           <br v-if="showEditButton(props.row)" />
            <router-link
              v-if="showEditButton(props.row) && $props.orderStatus != 'partnerNation' && (!isPartnerAccount || $props.orderStatus == 'unsigned')" 
              class="btn-link btn-primary"
              :to="'/order/edit/' + props.row.orderId"
              :aria-label="`Edit Order No ${props.row.orderId}`"
            >
              <i class="tim-icons icon-pencil"></i>
              <span class="hide-if-small-screensize">Edit</span>
            </router-link>
            <br v-if="showEditButton(props.row)  && $props.orderStatus != 'partnerNation' && (!isPartnerAccount || $props.orderStatus == 'unsigned')" />
            <a
              href="##"
              @click="clickShowDetailsModal(props.row.orderId)"
              :aria-label="`More details for order no ${props.row.orderId}`"
              class="btn-link btn-warning"
            >
              <i class="tim-icons icon-notes"></i>
              <span class="hide-if-small-screensize">More</span>
            </a>
          </template>
        </el-table-column>
        <el-table-column
          sortable
          prop="orderId"
          label="Order No."
          minWidth="130"
        >
          <template slot-scope="order">{{ order.row.orderId }}</template>
        </el-table-column>
        <el-table-column
          v-if="$props.orderStatus != 'draft'"
          sortable
          prop="requisitionNumber"
          label="Requisition #"
          minWidth="160"
        >
          <template slot-scope="order">{{
            order.row.requisitionNumber
          }}</template>
        </el-table-column>
        <el-table-column
          v-for="column in tableColumns"
          sortable
          :key="column.label"
          :min-width="column.minWidth"
          :prop="column.prop"
          :label="column.label"
        ></el-table-column>
        <!-- Logistics, Finance, Organization, Overdue / Delinquent. -->
        <el-table-column
          sortable
          prop="assignedLogisticsUser"
          label="Logistics"
          minWidth="180"
        >
          <template  slot-scope="order">
          <i v-if="(order.row.logisticsUser ? order.row.logisticsUser.approvalStatusId == lockedStatusId : false)" class="tim-icons icon-lock-circle"></i>
          <span style="background: none;"> {{ order.row.assignedLogisticsUser }}</span>
          </template>
        </el-table-column>
        <el-table-column
          sortable
          prop="assignedFinanceUser"
          label="Finance"
          minWidth="180"
        >
          <template  slot-scope="order">
          <i v-if="(order.row.financeUser ? order.row.financeUser.approvalStatusId == lockedStatusId : false)" class="tim-icons icon-lock-circle"></i>
          <span style="background: none;"> {{ order.row.assignedFinanceUser }}</span>
          </template>
        </el-table-column>
        <el-table-column
          v-if="$props.orderStatus == 'organization' "
          sortable
          prop="organization"
          label="Organization"
          minWidth="160"
        >
          <template  slot-scope="order">
            <span style="background: none;"> {{ order.row.organization }}</span>
          </template>
        </el-table-column>
        <el-table-column
          v-if="$props.orderStatus == 'partnerNation' "
          sortable
          prop="assignedPartnerNationUser"
          label="Partner Nation"
          minWidth="160"
        >
          <template  slot-scope="order">
          <i v-if="(order.row.partnerNationUser ? order.row.partnerNationUser.approvalStatusId == lockedStatusId : false)" class="tim-icons icon-lock-circle"></i>
          <span style="background: none;"> {{ order.row.assignedPartnerNationUser }}</span>
          </template>
        </el-table-column>

        <el-table-column
          v-if="
            $props.orderStatus == 'submitted' ||
            $props.orderStatus == 'organization'
          "
          sortable
          prop="overdueForecast"
          label="Overdue / Delinquent"
          minWidth="250"
        >
          <template slot-scope="order">
              <span v-html="order.row.overdueForecast"></span>
          </template>
        </el-table-column>
        
      </el-table>
      <b-modal
        ref="showDetailsModal"
        scrollable
        hide-footer
        hide-header
        no-close-on-backdrop
        size="lg"
        body-class="custom_alert_body"
      >
        <div class="alert_header align-center">
          <br />
          Additional Information for Order ID: {{ this.selectedOrderId }}
        </div>
        <div class="container">
          <div class="row">
            <div class="col-sm-12">
              <label for="organization">Organization:</label>
              <base-input
                id="organization"
                disabled
                v-model="this.organization"
              ></base-input>
            </div>
            <div class="col-sm-12">
              <label for="agreedReturnDate">Agreed Return Date:</label>
              <base-input
                id="agreedReturnDate"
                disabled
                v-model="this.agreedReturnDateLabel"
              ></base-input>
            </div>
            <div class="col-sm-6">
              <label for="deliveryStartDate">Delivery Start Date</label>
              <base-input
                id="agreedReturnDate"
                disabled
                v-model="this.deliveryStartDateLabel"
              ></base-input>
            </div>
            <div class="col-sm-6">
              <label for="deliveryEndDate">Delivery End Date</label>
              <base-input
                id="agreedReturnDate"
                disabled
                v-model="this.deliveryEndDateLabel"
              ></base-input>
            </div>
          </div>
        </div>

        <div class="alert_footer align-center">
          <base-button
            type="primary"
            @click="clickCloseModal()"
            class="btn-primary"
          >
            <i class="tim-icons icon-double-left"></i> Return to Table
          </base-button>
        </div>
      </b-modal>
    </div>

    <div class="row justify-content-end">
      <label for="ResultsPerPageDropdown" class="results-per-page"
        >Results Per Page:</label
      >
      <el-select
        id="ResultsPerPageDropdown"
        v-model="selectedResultsPerPage"
        readonly="false"
        name="PageOptions"
        class="select-primary"
      >
        <el-option
          v-for="(item, index) in getResultsPerPageOptions"
          :value="item"
          class="select-primary"
          :key="index"
        ></el-option>
      </el-select>

      <base-pagination
        :perPage="selectedResultsPerPage"
        v-model="selectedPage"
        :pageCount="getTotalNumberOfPages"
      />
    </div>
  </div>
</template>

<script>
import { Modal, BasePagination } from "@/components";
import { Table, TableColumn, Select, Option } from "element-ui";
import { mapGetters, mapActions } from "vuex";
import Util from "@/util/util";
export default {
  props: ["orderStatus"],
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    Modal,
    BasePagination,
    [Select.name]: Select,
    [Option.name]: Option,
  },
  name: "ShowAllOrders",
  data: function () {
    return {
      selectedOrderId: 0,
      organization: "",
      lockedStatusId: 0,
      agreedReturnDateLabel: "",
      deliveryStartDateLabel: "",
      deliveryEndDateLabel: "",
      tableColumns: [
        {
          prop: "countryName",
          label: "Country",
          minWidth: 130,
          scope: "col",
        },
        {
          prop: "orderStatus",
          label: "Status",
          minWidth: 150,
          scope: "col",
        },
        {
          prop: "totalLabel",
          label: "Total",
          minWidth: 150,
          scope: "col",
        },
        {
          prop: "paymentMethod",
          label: "Method of Payment",
          minWidth: 200,
          scope: "col",
        },
        {
          prop: "usBuySell",
          label: "Buy/Sell",
          minWidth: 120,
          scope: "col",
        }
      ],
      searchText: "",
      searchTimeOut: null,
      selectedResultsPerPage: 5,
      selectedPage: 1,
      pagination: {},
    };
  },

  watch: {
    searchText() {
      clearTimeout(this.searchTimeOut);

      var self = this;
      self.searchTimeOut = setTimeout(function () {
        self.updateDashboard(
          self.$props.orderStatus,
          1,
          self.selectedResultsPerPage
        );
      }, 1000);
    },
    selectedResultsPerPage(value) {
      this.updateDashboard(this.$props.orderStatus, 1, value);
    },
    selectedPage(value) {
      //   let tempSearchCriteria = this.searchCriteria;
      this.updateDashboard(
        this.$props.orderStatus,
        value,
        this.selectedResultsPerPage
      );
    },
  },
  created() {
    this.pagination = Util.getInitialPaginationInfo();
    this.updateDashboard(
      this.$props.orderStatus,
      this.pagination.currentPage,
      this.pagination.perPage
    );
    this.lockedStatusId = Util.LOCKED;
  },
   computed: {
    ...mapGetters({
      draftOrders: "orders/draftOrders",
      activeOrders: "orders/activeOrders",
      completedOrders: "orders/completedOrders",
      organizationOrders: "orders/organizationOrders",
      partnerNationOrders: "orders/partnerNationOrders",
      unsignedPNOrders: "orders/unsignedPNOrders",
      searchCriteria: "orders/searchCriteria",
      searchResults: "orders/searchResults",
      isPartnerAccount: "authentication/isPartnerAccount",
      user: "users/user",
    }),
    isInCompleteOrder() {
      return this.orderStatus !== "completed";
    },
    getServerResults() {
      if (!Util.isNullOrEmpty(this.searchCriteria)) {
        return this.searchResults;
      } else {
        return [];
      }
    },
    getResultsPerPageOptions() {
      return Util.getInitialPaginationInfo().perPageOptions;
    },
    getTotalNumberOfPages() {
      return Util.isNullOrEmpty(this.getResults)
        ? 1
        : this.getResults.pageCount;
    },
    getResults() {
      if (this.$props.orderStatus === "organization") {
        if(this.isPartnerAccount) {
          return this.partnerNationOrders;
        }
        else
          return this.organizationOrders;
      } else if (this.$props.orderStatus === "partnerNation") {
        return this.partnerNationOrders;
      } else if (this.$props.orderStatus === "draft") {
        return this.draftOrders;
      } else if (this.$props.orderStatus === "submitted") {
        return this.activeOrders;
      } else if (this.$props.orderStatus === "completed") {
        return this.completedOrders;
      } else if (this.$props.orderStatus === "unsigned") {
        return this.unsignedPNOrders;
      }
      return Util.isNullOrEmpty(this.getServerResults)
        ? []
        : this.getServerResults.results;
    },
    getMinWidth() {
      return this.$props.orderStatus === "draft" ? 180 : 240;
    },
    getOrders() {
      if (this.$props.orderStatus === "draft") {
        return this.draftOrders;
      } else if (this.$props.orderStatus === "submitted") {
        return this.activeOrders;
      } else if (this.$props.orderStatus === "completed") {
        return this.completedOrders;
      } else if (this.$props.orderStatus === "organization") {
        if(this.isPartnerAccount)
          return this.partnerNationOrders;
        else
          return this.organizationOrders;
      } else if (this.$props.orderStatus === "partnerNation") {
        return this.partnerNationOrders;
      } else if (this.$props.orderStatus === 'Unsigned') {
        return this.unsignedPNOrders;
      }
    },
  },
  methods: {
    ...mapActions({
      getUserOrdersByStatus: "orders/getUserOrdersByStatus",
      getAllOrdersByOrganization: "orders/getAllOrdersByOrganization",
      getAllOrdersByPartnerNation: "orders/getAllOrdersByPartnerNation",
      getAllOrdersByParnationOrderUnsigned: "orders/getAllOrdersByParnationOrderUnsigned",
      getUserOrdersByStatusForExportToExcel:
        "orders/getUserOrdersByStatusForExportToExcel",
      getAllOrdersByOrganizationForExportToExcel:
        "orders/getAllOrdersByOrganizationForExportToExcel",
      getSearchResults: "orders/getSearchResults",
      getUserByEmail: "users/getUserByEmail",
      clearSearchResults: "orders/clearSearchResults",
      getUserOrdersByPnPartnerNationorExportToExcel: "orders/getUserOrdersByPnPartnerNationorExportToExcel",
      getUserUnsignedOrdersExportToExcel: "orders/getUserUnsignedOrdersExportToExcel",
      getUserOrdersByCountryForExportToExcel: "orders/getUserOrdersByCountryForExportToExcel"
    }),
   
   async updateDashboard(
      orderStatus,
      currentPage = this.pagination.currentPage,
      perPage = this.pagination.perPage
    ) {
      let apiInfo = {
        orderStatus: orderStatus,
        pageNumber: currentPage,
        resultsPerPage: perPage,
        searchText: this.searchText,
        id: this.user.id
      };
      if (this.$props.orderStatus === "organization") {
        if(this.isPartnerAccount) {
          this.getAllOrdersByPartnerNation(apiInfo);
        } else
          this.getAllOrdersByOrganization(apiInfo);
      }
      else if(this.$props.orderStatus === "partnerNation"){
        this.getAllOrdersByPartnerNation(apiInfo);         
      } else if(this.$props.orderStatus === 'unsigned') {
        this.getAllOrdersByParnationOrderUnsigned(apiInfo);
      }
      else {
        this.getUserOrdersByStatus(apiInfo);
      }
    },
    exportToExcel() {
      let apiInfo = {
        orderStatus: this.$props.orderStatus,
        pageNumber: 1,
        resultsPerPage: 10,
        searchText: this.searchText,
      };
      let ctx = this;
      if (this.$props.orderStatus === "organization") {
        if(this.isPartnerAccount) {
          // this is for partnerNation Country tab
          this.getUserOrdersByCountryForExportToExcel(apiInfo).then(
            (result) => {
              if(result) {
                ctx.$toast.success("File Was Exported Successfully");
              } else {
                ctx.$toast.error("Error On Exporting!");
              }
            }
          );
        } else {
          this.getAllOrdersByOrganizationForExportToExcel(apiInfo).then(
            (result) => {
              if(result) {
                ctx.$toast.success("File Was Exported Successfully");
              } else {
                ctx.$toast.error("Error On Exporting!");
              }
            }
          );
        }
      } else if(this.$props.orderStatus === 'unsigned') {
        this.getUserUnsignedOrdersExportToExcel(apiInfo).then((ret) => {
          if(result) {
            ctx.$toast.success("File Was Exported Successfully");
          } else {
            ctx.$toast.error("Error On Exporting!");
          }
        });
      } else if(this.$props.orderStatus === "partnerNation") {
        // this will be a tab in partnernation manager export
        this.getUserOrdersByPnPartnerNationorExportToExcel(apiInfo).then(
          (result) => {
            if(result) {
              ctx.$toast.success("File Was Exported Successfully");
            } else {
              ctx.$toast.error("Error On Exporting!");
            }
          }
        );
      } else {
        // exporting orders for normal status
        this.getUserOrdersByStatusForExportToExcel(apiInfo).then((result) => {
          if(result) {
            ctx.$toast.success("File Was Exported Successfully");
          } else {
            ctx.$toast.error("Error On Exporting!");
          }
        });
      }
    },
    showEditButton(rowOrder) {
      if (this.$props.orderStatus && 
        this.$props.orderStatus.toUpperCase() === "COMPLETED" || 
        this.$props.orderStatus && 
        this.$props.orderStatus.toUpperCase() === "CANCELLED") {
        return false;
      }
      if (this.$props.orderStatus != "organization") {
        return true;
      }
      if (!Util.isNullOrEmpty(rowOrder.logisticsUser) && !Util.isNullOrEmpty(rowOrder.logisticsUser.id) && rowOrder.logisticsUser.id == this.user.id)
     {
        return true;
      } else if (!Util.isNullOrEmpty(rowOrder.financeUser) &&  !Util.isNullOrEmpty(rowOrder.financeUser.id) && rowOrder.financeUser.id == this.user.id) {
        return true;
      } else {
        return false;
      }
    },
    tableRowClassName({ row, column }) {      
      if (column.property === 'overdueForecast' && row.overdueForecast.includes("Past Due") ) {
        return {
          background: "#ffcece"
        };
      }
    },
    getOrderById(orderIdFromHtml) {
      return this.getOrders.results.find(
        (order) => order.orderId === orderIdFromHtml
      );
    },
    clickShowDetailsModal(orderIdFromHtml) {
      this.selectedOrderId = orderIdFromHtml;
      this.organization = this.getOrderById(orderIdFromHtml).organization;
      this.agreedReturnDateLabel =
        this.getOrderById(orderIdFromHtml).agreedReturnDateLabel;
      this.deliveryStartDateLabel =
        this.getOrderById(orderIdFromHtml).deliveryStartDateLabel;
      this.deliveryEndDateLabel =
        this.getOrderById(orderIdFromHtml).deliveryEndDateLabel;
      this.$refs.showDetailsModal.show();
    },
    clickCloseModal() {
      this.$refs.showDetailsModal.hide();
    },
  },
};
</script>

<style lang="scss" scoped>
.el-tooltip .btn-link .btn-warning .focusing {
  color: orange !important;
}

@media only screen and (max-width: 2038px) {
  .hide-if-large-screensize {
    display: none;
  }
}

@media only screen and (max-width: 800px) {
  .hide-if-medium-screensize {
    display: none;
  }
}
</style>
